import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Message } from 'primeng/api';
import { SearchText } from '../../../observation/model/searchTexts.model';
import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { AllTableRecordType, ApprovalType, PermitStatus } from '../../services/permittowork-constants.service';
import { PTWPermission } from '../model/PTWPermission.model';
import { AttendeeRecords, PTWTablesRecords, TRICRecords } from '../model/PTWTablesRecords.model';

@Component({
  selector: 'ara-ptw-all-tables-records',
  templateUrl: './ptw-all-tables-records.component.html',
  styleUrls: ['./ptw-all-tables-records.component.css']
})
export class PtwAllTablesRecordsComponent implements OnInit {

  @Input() RecordType: number;
  @Input() inputRecords: PTWTablesRecords[];
  @Input() TRICinputRecords: TRICRecords[] = [];
  @Input() PermitId: number = 0;
  @Input() LastValueOfRecord: any = 1;
  @Input() LastValueofAttendeeRecord: number = 1;
  @Input() Permissions: PTWPermission = new PTWPermission();
  @Input() addRecords : boolean = false;
  @Input() permitApplicant : number = 0;
  @Output() onTableRecordUpdate = new EventEmitter();

  loggedInUserJSON: any;
  ValidateTimeFrom: any;
  ValidateTimeTo: any;
  AttendeeRecords: AttendeeRecords[] = [];
  AttendeeRecord: AttendeeRecords = new AttendeeRecords();
  TRICinputRecord: TRICRecords = new TRICRecords();
  inputRecord: PTWTablesRecords = {
    id: 0,
    PermitId: 0,
    RecordType: 0,
    IsApproved: false,
    Remarks: "",
    ValidationTimeFrom: new Date(),
    ValidationTimeTo: new Date(),
    user: 0,
    date: new Date(),
    username: "",
    designation: "",
  };
  OAFDialog: boolean = false;
  SafetyCoordinatorDialog: boolean = false;
  ValidationDialog: boolean = false;
  AcceptanceDialog: boolean = false;
  SuspensionDialog: boolean = false;
  TRICDialog: boolean = false;
  AttendeeDialog: boolean = false;
  productDialog: boolean = false;
  gasTestRecords: PTWTablesRecords[];
  clonedRecord: { [s: string]: PTWTablesRecords; } = {};
  IsRecordNeedToAdd: boolean = false;
  searchTexts: SearchText;
  allUsers: any[] = [];
  OACUserSuggestion :any[] = [];
  IsEditRecord: boolean = false;
  ApprovalType = ApprovalType;
  AllTableRecordType = AllTableRecordType;
  PermitStatus = PermitStatus;
  approvals: { label: string; value: number; }[];
  acceptance: { label: string; value: number; }[];
  lastValue: number = 1;
  SelectedOACUser: any = {};
  attendeeFormGroup: FormGroup;
  tricNote: Message[] = [{ severity: "info", summary: 'Note: Click on Attendee Name or Position to edit data' }];


  constructor(private baseService: BaseService, private commonService: CommonService,private fb: FormBuilder) {
    this.searchTexts = new SearchText();
  }

  ngOnInit(): void {
    this.attendeeFormGroup = new FormGroup({
      attendeeArray: new FormArray([])
    });
    this.attendeeFormGroup['attendee']
    this.getAllUsers();
    if (!this.inputRecords) {
      this.inputRecords = [];
    }

    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.approvals = [{ label: "Approve", value: 1 }, { label: "Reject", value: 0 }]
    this.acceptance = [{ label: "Accept", value: 1 }, { label: "Reject", value: 0 }]
    this.lastValue = this.LastValueOfRecord;
  }

  createAttendeeFormGroup(record: AttendeeRecords) {
    return this.fb.group({
      attendeeName: new FormControl('',[Validators.required,this.noWhitespaceValidator]),
      attendeePosition: new FormControl('',[Validators.required,this.noWhitespaceValidator])
    });
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  getAllUsers() {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = "";
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersData.bind(this));
  }

  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response.Success) {
      this.allUsers = response.Result;
      if (this.allUsers && this.allUsers.length) {
        this.inputRecords.forEach(s => {
          s.username = this.allUsers.find(u => u.UserId == s.user).FullName;
          s.designation = this.allUsers.find(u => u.UserId == s.user).Designation;
        })
        this.TRICinputRecords.forEach(s => {
          s.username = this.allUsers.find(u => u.UserId == s.user).FullName;
        })
      }
    }
  }

  closePopUp() {
    this.SelectedOACUser = {};
    this.inputRecord = {
      id: 0,
      PermitId: 0,
      RecordType: 0,
      IsApproved: false,
      Remarks: "",
      user: this.loggedInUserJSON.UserId,
      date: new Date(),
      ValidationTimeFrom: new Date(),
      ValidationTimeTo: new Date(),
      username: this.loggedInUserJSON.FullName,
      designation: this.loggedInUserJSON.Designation,
    };
  }

  onRowEditInit(record: PTWTablesRecords) {
    this.clonedRecord[record.id] = { ...record };
    delete this.clonedRecord[record.id];
  }

  saveRecord(Type, IsApproved) {

    switch (Type) {
      case AllTableRecordType.OtherAffectedCustodian:
        this.LastValueOfRecord = this.inputRecords.length > 0 ? this.LastValueOfRecord + 1 : 1;
        this.inputRecords.push({
          id: this.LastValueOfRecord.toString(),
          PermitId: this.PermitId,
          RecordType: AllTableRecordType.OtherAffectedCustodian,
          IsApproved: IsApproved,
          Remarks: this.inputRecord.Remarks,
          ValidationTimeFrom: null,
          ValidationTimeTo: null,
          user: this.SelectedOACUser.UserId,
          OtherAffectedRS: this.loggedInUserJSON.UserId,
          date: moment(
            moment.utc(new Date()).local()
          ).toDate(),
          username: this.SelectedOACUser.FullName,
          designation: this.SelectedOACUser.Designation
        });
        this.OAFDialog = false;
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.SafetyCoordination:
        this.LastValueOfRecord = this.inputRecords.length > 0 ? this.LastValueOfRecord + 1 : 1;
        this.inputRecords.push({
          id: this.LastValueOfRecord,
          PermitId: this.PermitId,
          RecordType: AllTableRecordType.SafetyCoordination,
          IsApproved: IsApproved,
          Remarks: this.inputRecord.Remarks,
          ValidationTimeFrom: null,
          ValidationTimeTo: null,
          user: this.loggedInUserJSON.UserId,
          date: this.inputRecord.date,
          username: this.loggedInUserJSON.FullName,
          designation: this.loggedInUserJSON.Designation
        });
        this.SafetyCoordinatorDialog = false;
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Validation:
        this.LastValueOfRecord = this.inputRecords.length > 0 ? this.LastValueOfRecord + 1 : 1;
        this.inputRecords.push({
          id: this.LastValueOfRecord.toString(),
          PermitId: this.PermitId,
          RecordType: AllTableRecordType.Validation,
          IsApproved: IsApproved,
          Remarks: this.inputRecord.Remarks,
          ValidationTimeFrom: this.inputRecord.ValidationTimeFrom,
          ValidationTimeTo: this.inputRecord.ValidationTimeTo,
          user: this.loggedInUserJSON.UserId,
          date: this.inputRecord.date,
          username: this.loggedInUserJSON.FullName,
          designation: this.loggedInUserJSON.Designation
        });
        this.ValidationDialog = false;
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Acceptance:
        this.LastValueOfRecord = this.inputRecords.length > 0 ? this.LastValueOfRecord + 1 : 1;
        this.inputRecords.push({
          id: this.LastValueOfRecord.toString(),
          PermitId: this.PermitId,
          RecordType: AllTableRecordType.Acceptance,
          IsApproved: IsApproved,
          Remarks: this.inputRecord.Remarks,
          ValidationTimeFrom: null,
          ValidationTimeTo: null,
          user: this.loggedInUserJSON.UserId,
          date: this.inputRecord.date,
          username: this.loggedInUserJSON.FullName,
          designation: this.loggedInUserJSON.Designation
        });
        this.AcceptanceDialog = false;
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Suspension:
        this.LastValueOfRecord = this.inputRecords.length > 0 ? this.LastValueOfRecord + 1 : 1;
        this.inputRecords.push({
          id: this.LastValueOfRecord.toString(),
          PermitId: this.PermitId,
          RecordType: AllTableRecordType.Suspension,
          IsApproved: IsApproved,
          Remarks: this.inputRecord.Remarks,
          ValidationTimeFrom: null,
          ValidationTimeTo: null,
          user: this.loggedInUserJSON.UserId,
          date: this.inputRecord.date,
          username: this.loggedInUserJSON.FullName,
          designation: this.loggedInUserJSON.Designation
        });
        this.SuspensionDialog = false;
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.TRICTalk:
        if (this.IsEditRecord) {
          let index = this.TRICinputRecords.findIndex(s => s.id == this.TRICinputRecord.id);
          this.TRICinputRecords[index] = this.TRICinputRecord;
          this.TRICDialog = false;
          this.IsEditRecord = false;
          this.onTableRecordUpdate.emit(this.TRICinputRecords);
        }
        else {
          this.LastValueOfRecord = this.TRICinputRecords.length > 0 ? this.LastValueOfRecord + 1 : 1;
          this.TRICinputRecord.id = this.LastValueOfRecord;
          this.TRICinputRecord.PermitId = this.PermitId;
          this.TRICinputRecord.user = this.loggedInUserJSON.UserId;
          this.TRICinputRecord.username = this.loggedInUserJSON.FullName;
          this.TRICinputRecord.date = new Date();
          this.TRICinputRecord.RecordType = AllTableRecordType.TRICTalk;
          this.TRICinputRecords.push(this.TRICinputRecord);
          this.TRICDialog = false;
          this.onTableRecordUpdate.emit(this.TRICinputRecords);
        }
        break;
      default:
        break;
    }

    this.inputRecord = {
      id: 0,
      PermitId: 0,
      RecordType: 0,
      IsApproved: false,
      Remarks: "",
      ValidationTimeFrom: new Date(),
      ValidationTimeTo: new Date(),
      user: this.loggedInUserJSON.UserId,
      date: new Date(),
      username: this.loggedInUserJSON.FullName,
      designation: this.loggedInUserJSON.Designation
    };
  }

  onRowDeleteInit(index: number, type) {
    switch (type) {
      case AllTableRecordType.OtherAffectedCustodian:
        this.inputRecords.splice(index, 1);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.SafetyCoordination:
        this.inputRecords.splice(index, 1);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Validation:
        this.inputRecords.splice(index, 1);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Acceptance:
        this.inputRecords.splice(index, 1);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Suspension:
        this.inputRecords.splice(index, 1);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.TRICTalk:
        this.TRICinputRecords.splice(index, 1);
        this.onTableRecordUpdate.emit(this.TRICinputRecords);
        break;
      default:
        break;
    }
  }
  onRowEditSave(product: PTWTablesRecords, index: number, type) {
    switch (type) {
      case AllTableRecordType.OtherAffectedCustodian:
        product.OtherAffectedRS = this.loggedInUserJSON.UserId;
        this.inputRecords.splice(index, 1, product);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.SafetyCoordination:
        this.inputRecords.splice(index, 1, product);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Validation:
        this.inputRecords.splice(index, 1, product);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Acceptance:
        this.inputRecords.splice(index, 1, product);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      case AllTableRecordType.Suspension:
        this.inputRecords.splice(index, 1, product);
        this.onTableRecordUpdate.emit(this.inputRecords);
        break;
      default:
        break;
    }
  }

  viewTRICRecordDetails(ri) {
    this.TRICinputRecord = new TRICRecords();
    this.TRICinputRecord = this.TRICinputRecords[ri];
    this.IsEditRecord = true;
    this.TRICDialog = true;
  }
  EmptyTricRecord() {
    this.AttendeeRecord = new AttendeeRecords();
    this.AttendeeDialog = true;
    const attendeeControls = <FormArray>this.attendeeFormGroup.controls['attendeeArray'];
    attendeeControls.setValidators(Validators.required);
    attendeeControls.controls = [];
    let loopValue = 0
    if(this.TRICinputRecord.Attendee.length < this.TRICinputRecord.NoOfWorkParty ){
      loopValue = this.TRICinputRecord.NoOfWorkParty - this.TRICinputRecord.Attendee.length;
    }
    else{
      loopValue = this.TRICinputRecord.NoOfWorkParty
    }
    for(var i= 0; i < loopValue ;i++ ){
      attendeeControls.push(this.createAttendeeFormGroup({
        AttendeeName:'',
        AttendeePosition:''
        }));
    }
  }
  EmptyTRICRecord() {
    this.TRICDialog = true;
    this.TRICinputRecord = new TRICRecords();
  }
  saveAttendeeRecord(attendeeGroup:FormGroup[]) {
    //console.log(attendeeGroup);

    attendeeGroup.forEach(element => {
      this.LastValueofAttendeeRecord = this.LastValueofAttendeeRecord + 1;
      element.controls.attendeeName.value
      element.controls.attendeePosition.value
      this.TRICinputRecord.Attendee.push({
        id:this.LastValueofAttendeeRecord,
        AttendeeName:element.controls.attendeeName.value,
        AttendeePosition:element.controls.attendeePosition.value});
    });
    this.AttendeeDialog = false;
  }
  editTricRecord() {
    this.TRICinputRecord.Attendee.push(this.AttendeeRecord);
    this.AttendeeRecord = new AttendeeRecords();
    this.AttendeeDialog = false;
  }

  getUsersOnSearch(event) {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = 0;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersDataForOAC.bind(this));
  }

  callbackMethodForGetSearchResultsForUsersDataForOAC(response) {
    if (response.Success) {
      this.OACUserSuggestion = response.Result;
      if(this.RecordType == AllTableRecordType.OtherAffectedCustodian){
        this.OACUserSuggestion = this.OACUserSuggestion.filter(s=>s.UserId != this.loggedInUserJSON.UserId && s.UserId != this.permitApplicant);
      }
    }
  }

  selectUser(event) {
    if (event.UserId){
      this.SelectedOACUser = event;
    }
  }
}
